import { PageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";
import pageManagerConfigurationBase from "./PageManagerConfigurationBase.Generated";

const
    configuration: PageManagerConfiguration = {
        detailsPageMap: {
            ...pageManagerConfigurationBase.detailsPageMap,
            "Company": async () => (await import("./Pages/Entities/Companies/CompanyDetailsPage")).CompanyDetailsPage,
        },
        indexPageMap: {
            ...pageManagerConfigurationBase.indexPageMap,
        },
        routes: {
            ...pageManagerConfigurationBase.routes,
            "/": async () => (await import("./Pages/DemoDashboardPage")).DemoDashboardPage,
            "/login/": async () => (await import("@seriously-rad/seriouslyrad-framework-core/Ui/Pages/LoginPage")).LoginPage,
            "/test/": async () => (await import("./Pages/TestPage")).TestPage,
        }
    };

export default configuration;